import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { Link } from 'react-router-dom';
import { Icon, MobileItemList } from 'Components';
import './SummaryList.css';

const SummaryList = props => (
  <div className="summary-list">
    <div className="summary-list__header">
      <h4>{props.title}</h4>
    </div>
    <div className="summary-list__body">
      <MobileItemList {...props} />
    </div>
    <div className={`summary-list__footer ${!props.data.data.length !== 0 ? 'summary-list__footer__additional-padding' : ''}`} >
      {props.data.data.length !== 0 &&
      <Link to={props.data.code}>
        <span>{i18n.t('common:view more')}</span>
        <span className="summary-list__footer__icon">
          <Icon icon="chevron_right" />
        </span>
      </Link>}
    </div>
  </div>
);

SummaryList.propTypes = {
  isLoading: PropTypes.bool,
  title: PropTypes.string,
  data: PropTypes.shape({
    code: PropTypes.string,
    data: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  description: PropTypes.shape({}),
};

SummaryList.defaultProps = {
};

export default SummaryList;



// WEBPACK FOOTER //
// ./src/components/SummaryList/SummaryList.jsx